// src/components/ReaderGate.js
import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';

// Pass onWriterLogin={() => setShowWriterAuth(true)} from the parent
const ReaderGate = ({ onUnlock, onWriterLogin }) => {
  const { grantReaderAccess } = useAuth();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [company, setCompany] = useState('');
  const [newsletter, setNewsletter] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim()) { setError('Please enter your name'); return; }
    if (!email.trim()) { setError('Please enter your email'); return; }
    if (!email.includes('@')) { setError('Please enter a valid email'); return; }
    if (!company.trim()) { setError('Please enter your company'); return; }
    setLoading(true);
    setError('');
    try {
      await grantReaderAccess(name.trim(), email.trim().toLowerCase(), company.trim(), newsletter);
      onUnlock();
    } catch (err) {
      console.error('Error granting access:', err);
      setError('Something went wrong. Please try again.');
      setLoading(false);
    }
  };

  return (
    <div className="reader-gate">
      <div className="gate-content">
        <div className="gate-icon">
          <svg width="48" height="48" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
          </svg>
        </div>
        <h3 className="gate-title">Unlock this free article</h3>
        <p className="gate-description">
          Enter your details below to continue reading. No spam, just great content about employee benefits.
        </p>

        {/* Sign-in CTA for account holders */}
        {onWriterLogin && (
          <div className="gate-signin-cta">
            <p>
              Have an account?{' '}
              <button
                type="button"
                className="gate-signin-link"
                onClick={onWriterLogin}
              >
                Sign in to read instantly
              </button>
            </p>
            <p className="gate-writer-note">
              Avenir team members with an @avenir.com.ai account can also write articles.
            </p>
          </div>
        )}

        <div className="gate-divider">
          <span>or continue as guest</span>
        </div>

        <form onSubmit={handleSubmit} className="gate-form">
          {error && <div className="gate-error">{error}</div>}
          <div className="gate-field">
            <label htmlFor="gate-name">Name</label>
            <input id="gate-name" type="text" value={name} onChange={(e) => setName(e.target.value)} placeholder="Your full name" disabled={loading} />
          </div>
          <div className="gate-field">
            <label htmlFor="gate-email">Email</label>
            <input id="gate-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@company.com" disabled={loading} />
          </div>
          <div className="gate-field">
            <label htmlFor="gate-company">Company</label>
            <input id="gate-company" type="text" value={company} onChange={(e) => setCompany(e.target.value)} placeholder="Your company name" disabled={loading} />
          </div>
          <label className="gate-checkbox-label">
            <input
              type="checkbox"
              checked={newsletter}
              onChange={(e) => setNewsletter(e.target.checked)}
              className="gate-checkbox"
              disabled={loading}
            />
            <span>I'd like to receive emails about industry trend updates</span>
          </label>
          <button type="submit" className="btn btn-primary gate-submit" disabled={loading}>
            {loading ? (
              <><span className="btn-spinner"></span>Unlocking...</>
            ) : (
              'Continue Reading →'
            )}
          </button>
        </form>

        <p className="gate-privacy">
          By continuing, you agree to receive occasional emails from Avenir AI.
          We respect your privacy and will never share your information.
        </p>
      </div>
    </div>
  );
};

export default ReaderGate;